<template>
  <div class="text-gray-700">
    <h1 class="text-2xl font-bold text-gray-900 mb-1">Terms and Conditions</h1>
    <p class="text-sm text-gray-500 mb-6">LayUp Technologies Proprietary Limited — Save Now, Buy Later</p>

    <p class="text-sm leading-relaxed mb-6">
      The merchant ("the Seller") and the purchaser (hereinafter referred to as "You"), hereby agree to the following
      terms and conditions with regard to the sale of the goods by means of LayUp's voucher savings plan ("the Voucher
      Savings Plan").
    </p>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">1.</span> Agreement to Purchase
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">You agree:</p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">2.1. to buy goods using the Voucher Savings Plan;</p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">
        2.2. to pay for the goods by making a deposit and regular instalments towards the Voucher Savings Plan, within
        the predefined time-frame; and
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">
        2.3. that this Agreement represents the entire agreement between You and the Seller.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">3.</span> Voucher Savings Plan
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        A Voucher Savings Plan has terms and conditions specifically defined by the Seller offering it as a payment
        option. You may only redeem your Voucher Savings Plan with the Seller with which you signed up for the Voucher
        Savings Plan.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">4.</span> Ownership of Goods
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        You understand and agree that You will not become the owner of any goods until You have redeemed your Voucher
        Saving Plan. The Seller makes no guarantees as to availability of stock at the time of the Voucher Savings Plan
        being completed.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">5.</span> Fees and Interest
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        No interest or initiation fees will be charged on the Voucher Savings Plan.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">6.</span> VAT and Transferability
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">You understand and agree that:</p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">
        6.1. the purchase price of the goods includes VAT at the current rate of VAT;
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">
        6.2. each Voucher Savings Plan is not transferable and may not be redeemed by anyone else but You; and
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">
        6.3. if, at any time before You pay the full purchase price of the goods, the VAT rate is changed in relation to
        the goods, the Seller will be entitled to recover the VAT increase from you prior to release of the goods.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">7.</span> Payment Obligations
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        You must pay the monthly instalments on or before the due dates indicated in your Voucher Savings Plan until the
        final payment date. All amounts must be paid on the LayUp platform, as detailed in the Voucher Savings Plan.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">8.</span> Eligible Merchandise
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        At the Seller's discretion, certain merchandise may not qualify for purchase through the Voucher Savings Plan.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3"><span class="shrink-0">9.</span> Cancellations</h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        9.1. The Seller has set a predefined maximum savings goal ("Maximum Savings Goal"), which is the monetary target
        that unlocks the full benefits and/or rewards ("Reward") of the Voucher Savings Plan. No Reward, full or
        reduced, may be exchanged for cash.
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        9.2. In addition to the Maximum Savings Goal, the Seller has defined a minimum savings goal ("Minimum Savings
        Goal"), which is a minimum monetary amount that You must have paid in order to qualify for certain concessions
        from the Seller with regard to your Voucher Savings Plan.
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        9.3. If You cancel your Voucher Savings after reaching the Minimum Savings Goal but before reaching the Maximum
        Savings Goal, You can redeem your Voucher Savings Plan up to the value of what You would have paid towards it
        leading up to the point of cancellation. In this case, the Seller may grant a reduced Reward.
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        9.4. If You cancel your Voucher Savings Plan before reaching the Minimum Savings Goal, You may still redeem your
        Voucher Savings Plan up to the value You would have paid at the time of cancellation, but without the benefit of
        a Reward. If You seek a cash refund for such a cancellation, You will be liable for the transaction costs for
        all payments made by You leading up to the time of cancellation.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">10.</span> Failure to Pay
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        If You fail to fulfil your obligation to pay towards a Voucher Payment Plan by not later than the payment date/s
        scheduled, the Seller shall be entitled, after the grace period set on the LayUp platform (where applicable), to
        terminate this Agreement and, in that event, LayUp will refund all payments made by You in accordance with the
        provisions of clause 9.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">11.</span> Change of Contact Details
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        If your contact details or address change, You must notify LayUp within 7 (seven) days of such change.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3"><span class="shrink-0">12.</span> Assignment</h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        The Seller shall be entitled at any time to assign its right, title and interest in, to and under this Agreement
        to any other party. You shall not assign, or otherwise deal with any of your right, title and interest under
        this Agreement nor agree to do any such thing without the prior written consent of the Seller, which the Seller
        may withhold at its absolute discretion.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3"><span class="shrink-0">13.</span> Force Majeure</h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        Should the Seller be prevented from fulfilling any of its obligations to You as a result of any event of force
        majeure, then those obligations shall be deemed to have been suspended to that extent and for as long as the
        Seller is so prevented from fulfilling them. In the event that such event continues for more than 14 (fourteen)
        days after it has first occurred, then the Seller shall be entitled (but not obliged) to terminate all of its
        rights and obligations in terms of or arising out of these terms by giving notice to You.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">14.</span> Legal Proceedings
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        You hereby consent that the Seller may institute any legal proceedings that have to do with this Agreement on
        your account, in the magistrate's court, being any magistrate's court that has jurisdiction over this Agreement.
        The Seller may, however, choose to institute action against You in any other court having competent
        jurisdiction.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">15–16.</span> Personal Information
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        In this Agreement, personal information means any and all information that You give to us which is personal to
        You (for example: your name, identity number, phone number, etc.), which the Seller may store and process. LayUp
        will keep your personal information only for as long as we require or are required to, by law.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">17.</span> Disclosure of Personal Information
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        You agree and consent that the Seller may disclose your personal information to, where necessary:
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">17.1. any person working for them;</p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">
        17.2. any organisation which underwrites or supports any of their products which you wish to purchase;
      </p>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-10">
        17.3. any person to whom they transfer any of their rights or obligations under this Agreement; alternatively,
        anyone You authorise them to give personal information to.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3"><span class="shrink-0">18.</span> Amendments</h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        These terms and conditions may be amended from time to time, and in such a case the amended terms and conditions
        shall apply to You with immediate effect.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">19.</span> Legal Capacity
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        You must have the legally required capacity to enter into and be bound by this Agreement.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3"><span class="shrink-0">20.</span> Governing Law</h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        The Agreement is regulated in the Republic of South Africa by the applicable provisions of the Consumer
        Protection Act (68 of 2008).
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">21.</span> Acknowledgement
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        You confirm that the terms and conditions, the meaning and consequences of this Agreement have been presented
        and explained to You in a language that You understand. You also confirm that the risks relating to the
        Agreement, as well as your rights and obligations, have also been explained to you.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">22.</span> Amendment or Replacement
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        The Seller may at any time amend or replace these terms and conditions and if they do so, it does not mean a
        novation of the Agreement or any transaction or indebtedness.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">23.</span> Exclusions from Promotions
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        Voucher Savings Plans may be excluded from certain promotions, such as one-day deals, Black Friday and new store
        opening deals as well as specific offers where limited quantities apply. These will be noted in the promotion
        advertising communications.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3"><span class="shrink-0">24.</span> Plan Duration</h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        The total period of the Voucher Savings Plan is the period set out in the LayUp platform, and this may not be
        extended without the express consent of the Seller.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">25.</span> Cancellation Notice
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        We may give You notice in respect of cancellation of a Voucher Savings Plan by e-mail or SMS to the e-mail
        address and/or cell-phone number you have provided to us.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">26.</span> Collection of Goods
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        You must always produce a Voucher Savings Plan receipt and proof of identity when physically collecting goods on
        a completed Voucher Savings Plan.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3"><span class="shrink-0">27.</span> No Waiver</h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        No failure or delay by a party to enforce or exercise a right in terms of this Agreement will thereby be deemed
        to be a waiver or abandonment thereof.
      </p>
    </div>

    <div class="mb-6">
      <h2 class="flex gap-2 text-base font-bold text-gray-900 mb-3">
        <span class="shrink-0">28.</span> Entire Agreement
      </h2>
      <p class="text-sm text-gray-700 leading-relaxed mb-2 pl-5">
        This Agreement represents the entire agreement between You and the Seller in relation to your Voucher Savings
        Plan. No alterations or additions to this Agreement may be effected unless agreed to by both parties, reduced to
        writing and signed by You and a duly authorised representative of the Seller.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
